const withRowRenderer = (rowRendererFn) => {
  const tableRowFn = (props) => rowRendererFn({ ...props });
  return tableRowFn;
};

export default withRowRenderer;
